import * as React from 'react';
import logo from "../../../static/img/logo.svg"
import finance from "../../../static/img/left-nav/finance.svg"
import punjab from "../../../static/img/left-nav/punjab.svg"
import kpk from "../../../static/img/left-nav/kp.svg"
import sindh from "../../../static/img/left-nav/sindh.svg"
import balochistan from "../../../static/img/left-nav/balochistan.svg"
import islamabad from "../../../static/img/left-nav/islamabad.svg"

import '../../../static/css/dropdown-menu.css';

import {store} from "../../../store/store";
import {dashboardActions} from "../../dashboard/models/dashboard-slice";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import Api, {APIs} from "../../../Api";
import LeftMenuButton from "./LeftMenuButton";


const LeftMenuBar = () => {
    const [sectors, setSector] = useState<string[]>([]);
    // const [region, setRegion] = useState<string[]>([]);
    useEffect(() => {
        Api.get(APIs.MoPD_UNIQUE_LIST).then((payload: any) => {
            setSector(payload.sector);
        })
    }, []);
    const regions = [
        {name: "All", title:"All",  className: "bg-finance", imgSrc: finance, isSector: true,},
        {name: "Federal", title:"Cross-Provincial", className: "bg-social", imgSrc: islamabad, isSector: false},
        {name: "Punjab", title: 'Punjab', className: "bg-punjab", imgSrc: punjab, isSector: false},
        {name: "Khyber Pakhtunkhwa", title: 'Khyber Pakhtunkhwa', className: "bg-kp", imgSrc: kpk, isSector: false},
        {name: "Sindh", title: 'Sindh', className: "bg-sindh", imgSrc: sindh, isSector: false},
        {name: "Balochistan", title: 'Balochistan', className: "bg-energy", imgSrc: balochistan, isSector: false}]
    const setArrowIcon = (region: any) => {
        regions.forEach((info: any) => {
            const elem: any = document.getElementById(`${info["name"]}-toggle-div`)
            if(elem) elem.className = info["name"] === region["name"] ? "left-active" : "left";
        });
    }
    const navigate = useNavigate()
    const handleLeftMenuClick = (e: any, region: any, sro: string, sector: string, donor: string) => {
        navigate("/")

        store.dispatch(dashboardActions.setFilterParams({
            sro: sro,
            sector: sector,
            region: region["name"],
            donor: donor
        }))
        setArrowIcon(region)
    }

    return (
        <React.Fragment>
            <div className="side-nav left-nav" >
                <div className="card bg-logo" style={{
                    margin: "10px", borderRadius: "50px", width:"60px"
                }}>
                    <img alt={"logo"} src={logo} className="pt-0"/>
                </div>
                <div style={{ overflowY: "auto", height:"calc(100vh - 80px)"}}>
                {regions.map((region: any, index: number) =>
                    <div key={"regions-div-" + index}
                         className={"card " + region["className"]}
                         // style={{padding:"10px"}}
                        // onClick={(e) => {
                        //     if (!region.isSector)
                        //         handleLeftMenuClick(e, region, "all")
                        // }}
                    >
                        <LeftMenuButton key={"sdd-" + index} handleLeftMenuClick={handleLeftMenuClick}
                                        region={region}
                                        sectors={sectors}/>


                    </div>
                )}
                </div>
            </div>
        </React.Fragment>

    );
}
export default LeftMenuBar;
